import React, {ChangeEvent} from 'react';
import {useStyles} from "./ShowPaginationLarge.style";
import ShowPaginationProperties from "../ShowPaginationProperties";
import clsx from "clsx";
import {useI18nContext} from "../../../contexts/I18nContext";
import Width from "../../common/enums/Width";
import Alignment from "../../common/enums/Alignment";
import Box from "../../Box/Box";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';


const ShowPaginationLarge: React.FC<ShowPaginationProperties> = ({
                                                                      className = '',
                                                                      pagination,
                                                                      elementLabel,
                                                                      onChange
                                                                  }) => {
    const itemsPerPageValues = [5, 10, 15, 20, 30, 50, 100];
    const classes = useStyles();
    const i18n = useI18nContext();

    const goToPage = (page: number) => {
        if (page > pagination.pageCount || page <= 0) return;
        if (page === pagination.currentPage) return;
        onChange(page, pagination.pageSize);
    }

    const onItemsPerPageChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const pageSize = parseInt(event.target.value);
        onChange(1, pageSize);
    }

    return (
        <Box className={classes.box} width={Width.FULL_WIDTH}
             justifyContent={Alignment.SPACE_BETWEEN}>
            <div className={clsx(classes.pagination_container, className)}>
                <div className={classes.elements_count}>
                    <div>{pagination.elementsCount}</div>
                    <div>{elementLabel}</div>
                </div>
                <div className={classes.items_per_page}>
                    <select onChange={onItemsPerPageChange} value={pagination.pageSize}>
                        {itemsPerPageValues.map((value, i) =>
                            <option key={i} value={value}>{value}</option>
                        )}
                    </select>
                    <div>{i18n.translate("ITEMS_PER_PAGE")}</div>
                </div>
                <div className={classes.page_elements}>
                    <div onClick={() => goToPage(1)}
                         className={clsx(classes.page_button, pagination.currentPage === 1 && classes.disabled)}>
                        <FirstPageIcon/>
                        <div>{i18n.translate("FIRST")}</div>
                    </div>
                    <div onClick={() => goToPage(pagination.currentPage - 1)}
                         className={clsx(classes.page_button, pagination.currentPage === 1 && classes.disabled)}>
                        <ChevronLeftIcon/>
                        <div>{i18n.translate("PREVIOUS")}</div>
                    </div>
                    <div className={classes.current_page}>{`${pagination.currentPage} / ${pagination.pageCount}`}</div>
                    <div
                        onClick={() => goToPage(pagination.currentPage + 1)}
                        className={clsx(classes.page_button, pagination.currentPage === pagination.pageCount && classes.disabled)}>
                        <div>{i18n.translate("NEXT")}</div>
                        <ChevronRightIcon/>
                    </div>
                    <div
                        onClick={() => goToPage(pagination.pageCount)}
                        className={clsx(classes.page_button, pagination.currentPage === pagination.pageCount && classes.disabled)}>
                        <div>{i18n.translate("LAST")}</div>
                        <LastPageIcon/>
                    </div>
                </div>
            </div>
        </Box>
    )
}
export default ShowPaginationLarge;